import { useConfigurationContext } from '@nv/contexts'
import clsx from 'clsx'
import LanguagesDropdown from '../../languages_dropdown/LanguagesDropdown'
import styles from './LoginTopBar.module.scss'

export const LoginTopBar = ({ logo, className }: any) => {
  const { languages } = useConfigurationContext()

  return (
    <div className={clsx(styles['container'], styles[className])}>
      <div className={styles['logo']}>{logo}</div>
      {languages && (
        <div className={styles['dropdown-container']}>
          <LanguagesDropdown />
        </div>
      )}
    </div>
  )
}
